import { get } from 'lodash';
/**
 * Attempting to parse all locals messages from DOM
 */
export function parseMessages(templatePath) {
    if (!templatePath) {
        console.warn('Missing template name');
    }
    try {
        const templateObjPath = templatePath.replaceAll('/', '.');
        const localsAllMessages = JSON.parse(document.getElementById('data-messages').innerHTML || '{}');
        return get(localsAllMessages, templateObjPath, localsAllMessages);
    } catch (e) {
        console.warn('Please attach locales to DOM');
        return {}
    }
}